'use client'

import { useState, useEffect } from 'react'
import Link from 'next/link'
import { getLastShoppingLocation } from '@/app/_lib/services/RecentlyViewedService'

const ContinueShoppingLink = ({ className = '', children = 'Continue Shopping', onClick }) => {
    const [url, setUrl] = useState(null)

    useEffect(() => {
        setUrl(getLastShoppingLocation())
    }, [])

    if (!url) return null

    return (
        <Link href={url} className={className} onClick={onClick}>
            {children}
        </Link>
    )
}

export default ContinueShoppingLink
